import { base64Encode } from "@/utils/encode";
/**
 * 获取 URL 查询参数
 * @param str url字符串或search部分
 * @param fields 可选，指定要获取的字段（string 或 string[]）
 * @returns 返回指定字段的对象，支持类型推断
 */
export function getUriQuery<
  T extends Record<string, any> = Record<string, string>,
>(str: string, fields?: keyof T | (keyof T)[]): T {
  const query: Partial<T> = {};
  const searchParams = new URLSearchParams(str);

  // 处理 fields 参数
  let fieldArr: string[] | undefined;
  if (fields) {
    fieldArr = Array.isArray(fields)
      ? (fields as string[])
      : [fields as string];
  }

  if (fieldArr && fieldArr.length > 0) {
    // 只取指定字段，且都找到了就提前返回
    let foundCount = 0;
    for (const key of fieldArr) {
      const value = searchParams.get(key as string);
      if (value !== null) {
        query[key as keyof T] = value as any;
        foundCount++;
      }
      if (foundCount === fieldArr.length) break;
    }
    return query as T;
  }

  // 否则返回所有参数
  searchParams.forEach((value, key) => {
    query[key as keyof T] = value as any;
  });

  return query as T;
}

export const compactUriQuery = (query: Record<string, any>) => {
  const newQuery: Record<string, any> = {};
  Object.keys(query).forEach((key) => {
    if (query[key] !== undefined) {
      newQuery[key] = query[key];
    }
  });
  return newQuery;
};

export const getUri = (url: string, query: Record<string, any>) => {
  const searchParams = new URLSearchParams(query);
  let search = "";
  searchParams.forEach((value, key) => {
    search = `${search ? `${search}&` : ""}${key}=${value}`;
  });
  return `${url}${search ? `?${search}` : ""}`;
};

export const encodeUri = (str: string) => {
  return encodeURIComponent(str);
};

export const decodeUri = (url: string) => {
  try {
    return url.includes("%") ? decodeURIComponent(url) : url;
  } catch {
    return url;
  }
};

/**
 * 拼接URL参数并跳转
 * @param url 目标URL字符串
 * @param paramList 要携带的参数列表，不传则携带所有参数
 * @returns void
 */
export function appendUrlParams(url: string, paramList?: string[]): void {
  const currentParams = new URLSearchParams(window.location.search);
  const targetUrl = new URL(url, window.location.origin);

  // 如果指定了参数列表，只添加指定的参数
  if (paramList?.length) {
    paramList.forEach((param) => {
      const value = currentParams.get(param);
      if (value) {
        targetUrl.searchParams.set(param, value);
      }
    });
  } else {
    // 否则添加所有当前参数
    currentParams.forEach((value, key) => {
      targetUrl.searchParams.set(key, value);
    });
  }

  window.location.href = targetUrl.toString();
}

export const getTTLinkText = (encodedUrl: string): string => {
  return `snssdk1180://lynxview?bundle=url-add-product%2Ftemplate.js&channel=tea_selection_page&dynamic=1&hide_nav_bar=1&product_url=${encodedUrl}&status_bar_color=00000000&surl=https%3A%2F%2Flf16-gecko-source.tiktokcdn.com%2Fobj%2Fbyte-gurd-source-sg%2F8%2Fgecko%2Fresource%2Ftea_selection_page%2Furl-add-product%2Ftemplate.js&trans_status_bar=1&use_bdx=1&use_gecko_first=1`;
};

export const getAppDeepLinkUrlHashId = (hash_id: string): string => {
  return encodeURIComponent(
    base64Encode(`yoofinds://yoofinds/productEcho?hash_id=${hash_id}`)
  );
};
